import { BrowserAgent } from '@newrelic/browser-agent/loaders/browser-agent';
import type { AgentOptions } from '@newrelic/browser-agent/src/loaders/agent.js';

import type { DataLayerIntegrationInterface } from '../DataLayer/DataLayer.types';

export class NewRelicIntegration implements DataLayerIntegrationInterface {
  private agentOptions: AgentOptions | null = null;
  private static instance: NewRelicIntegration | null = null;
  private isProduction = false;

  constructor(agentOptions: AgentOptions, isProduction: boolean) {
    this.agentOptions = agentOptions;
    this.isProduction = isProduction;
  }

  public static getInstance(
    agentOptions: AgentOptions,
    isProduction: boolean
  ): NewRelicIntegration {
    NewRelicIntegration.instance ??= new NewRelicIntegration(
      agentOptions,
      isProduction
    );

    return NewRelicIntegration.instance;
  }

  public init() {
    if (this.agentOptions && this.isProduction) {
      new BrowserAgent(this.agentOptions);
    }
  }

  public trackEvent() {
    return;
  }

  public trackIdentification() {
    return;
  }

  public trackView() {
    return;
  }

  public addGlobalEventProperties() {
    return;
  }
}
